import { render, staticRenderFns } from "./ProjectRequestsList.vue?vue&type=template&id=4d80e48c&scoped=true&"
import script from "./ProjectRequestsList.vue?vue&type=script&lang=js&"
export * from "./ProjectRequestsList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRequestsList.vue?vue&type=style&index=0&id=4d80e48c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80e48c",
  null
  
)

export default component.exports